module.exports = __webpack_public_path__ + "static/media/wc-1.507ec505.jpg";